import { Typography } from "antd";
import PageLayout from "components/molecules/PageLayout";
import DataObjectSearch from "containers/DataObjectSearch";

const SearchPage = () => {
    return (
        <PageLayout
            mainContent={({ setBreadcrumbNavigationItems }: IPageLayoutMainContentProps) => <DataObjectSearch setBreadcrumbNavigationItems={setBreadcrumbNavigationItems} />}
            helpContent={<Typography>We're working on this documentation.</Typography>}
        />
    );
};

export default SearchPage;
